import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  ConsequencesEnum,
  ProbabilityEnum
} from '@app/components/osh/add-osh-analysis-dialog/add-osh-analysis.builder';
import { DangerousSituationDto } from '@app/shared/services/dtos/osh/dangerous-situation.dto';
import { DropdownItem } from '@app/shared/types/models/shared/dropdown-item';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-osh-dangerous-situation-item',
  imports: [MatIconModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './osh-dangerous-situation-item.component.html'
})
export class OshDangerousSituationItemComponent {
  protected dangerousSituation = input.required<DangerousSituationDto>();
  protected childrenVisible = false;

  public readonly consequences: DropdownItem<ConsequencesEnum>[] = [
    { value: ConsequencesEnum.VeryLow, label: 'osh.consequences-very-low' },
    { value: ConsequencesEnum.Low, label: 'osh.consequences-low' },
    { value: ConsequencesEnum.Medium, label: 'osh.consequences-medium' },
    { value: ConsequencesEnum.High, label: 'osh.consequences-high' },
    { value: ConsequencesEnum.VeryHigh, label: 'osh.consequences-very-high' }
  ];

  public readonly probabilities: DropdownItem<ProbabilityEnum>[] = [
    { value: ProbabilityEnum.Rare, label: 'osh.probability-rare' },
    { value: ProbabilityEnum.Unlikely, label: 'osh.probability-unlikely' },
    { value: ProbabilityEnum.Likely, label: 'osh.probability-possible' },
    { value: ProbabilityEnum.Possible, label: 'osh.probability-probable' },
    { value: ProbabilityEnum.AlmostCertain, label: 'osh.probability-almost-certain' }
  ];

  protected toggleChildren(): void {
    this.childrenVisible = !this.childrenVisible;
  }

  public setConsequencesLabel(consequences: string): string {
    return this.consequences.find(item => item.value === consequences).label;
  }

  public setProbabilityLabel(probability: string): string {
    return this.probabilities.find(item => item.value === probability).label;
  }
}
